interface FilterIconProps {
    className?: string
}

export default function FilterIcon({className}: FilterIconProps) {
    return (
        <svg xmlnsXlink="http://www.w3.org/1999/xlink"
             xmlns="http://www.w3.org/2000/svg"
             viewBox="0 0 640 640"
             className={className ?? 'h-5 w-5'}
        >
            <path fill="currentColor"
                  d="M160 448C142.3 448 128 433.7 128 416C128 398.3 142.3 384 160 384C177.7 384 192 398.3 192 416C192 433.7 177.7 448 160 448zM250.5 384C237.3 346.7 201.8 320 160 320C107 320 64 363 64 416C64 469 107 512 160 512C201.8 512 237.4 485.3 250.5 448L544 448C561.7 448 576 433.7 576 416C576 398.3 561.7 384 544 384L250.5 384zM512 224C512 241.7 497.7 256 480 256C462.3 256 448 241.7 448 224C448 206.3 462.3 192 480 192C497.7 192 512 206.3 512 224zM389.5 192L96 192C78.3 192 64 206.3 64 224C64 241.7 78.3 256 96 256L389.5 256C402.7 293.3 438.2 320 480 320C533 320 576 277 576 224C576 171 533 128 480 128C438.2 128 402.6 154.7 389.5 192z"/>
        </svg>
    )
}
